module.exports = __webpack_public_path__ + "37007c7c2f07d96ecc09ce635f952a0c.pdf";